import { useStore } from "vuex";
import AuthService from "@/apps/merchant3/services/merchant.login.service";
import IClerk from "@/types/clerk";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";

export default function useClerkPersistState(callback: () => boolean): void {
  const store = useStore();
  const authService = new AuthService();
  if (!store.state.clerk?.clerk?.salesClerkId) {
    if (sessionStorage.getItem(SessionStorageEnum.Clerk)) {
      authService.getClerk().then((response: IClerk) => {
        const clerk: IClerk = response;
        if (clerk) {
          // Setting Clerk
          store.dispatch("clerk/setClerk", clerk);
        } else {
          // throw error.
        }
        callback();
      });
    }
  } else {
    callback();
  }
}
